import React from "react";
import type { ValidationMessage } from "../model/types";

export function ValidationSummary({ messages }: { messages: ValidationMessage[] }): JSX.Element {
  if (!messages.length) {
    return (
      <div className="tw-mx-6 tw-mt-3 tw-rounded-xl tw-border tw-border-emerald-200 tw-bg-emerald-50 tw-px-4 tw-py-3 tw-text-sm tw-text-emerald-700">
        No validation issues found.
      </div>
    );
  }

  return (
    <div className="tw-mx-6 tw-mt-3 tw-rounded-xl tw-border tw-border-amber-200 tw-bg-amber-50 tw-p-4 tw-text-sm tw-text-amber-800">
      <p className="tw-mb-2 tw-font-semibold">Validation messages</p>
      <ul className="tw-list-disc tw-space-y-1 tw-pl-5">
        {messages.map((message, index) => (
          <li key={`${message.level}-${index}`}>{message.message}</li>
        ))}
      </ul>
    </div>
  );
}
